import React, { Component } from "react";
import { ConstantBasedPicker } from "@openimis/fe-core";
import { ENROLLMENT_STATUSES } from "../constants";

class EnrollmentStatusPicker extends Component {
  render() {
    return (
      <ConstantBasedPicker
        module="enrollment"
        label="status"
        constants={ENROLLMENT_STATUSES}
        {...this.props}
      />
    );
  }
}

export default EnrollmentStatusPicker;
